import { render, staticRenderFns } from "./ListSelector.vue?vue&type=template&id=72133bf8&scoped=true"
import script from "./ListSelector.vue?vue&type=script&lang=js"
export * from "./ListSelector.vue?vue&type=script&lang=js"
import style0 from "./ListSelector.vue?vue&type=style&index=0&id=72133bf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72133bf8",
  null
  
)

export default component.exports